// AI Settings List Component (Welcome Page用)
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { setAiSettingSettings, setAiSettingLoading, setAiSettingError, removeAiSetting } from '../../actions';
import { fetchAiSettings, deleteAiSetting } from '../../api/ai_settingApi';
import AiSettingModal from './AiSettingModal';
import './ai-setting-list.css';
/**
 * AI設定一覧コンポーネント（Welcome Page用）
 */
const AiSettingList = ({ _settings, _loading, _error, t, dispatch }) => {
    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        mode: 'create'
    });
    useEffect(() => {
        loadSettings();
    }, []);
    const loadSettings = async () => {
        dispatch(setAiSettingLoading(true));
        dispatch(setAiSettingError(null));
        try {
            const settings = await fetchAiSettings();
            dispatch(setAiSettingSettings(settings));
        }
        catch (error) {
            dispatch(setAiSettingError('設定の読み込みに失敗しました'));
        }
    };
    const handleNewSetting = () => {
        setModalConfig({
            isOpen: true,
            mode: 'create'
        });
    };
    const handleEditSetting = (setting) => {
        setModalConfig({
            isOpen: true,
            mode: 'edit',
            settingData: setting,
            settingId: setting.id
        });
    };
    const handleViewSetting = (setting) => {
        setModalConfig({
            isOpen: true,
            mode: 'view',
            settingData: setting,
            settingId: setting.id
        });
    };
    const handleCloseModal = () => {
        setModalConfig({
            ...modalConfig,
            isOpen: false
        });
    };
    const handleSaveSuccess = () => {
        loadSettings();
    };
    const handleDeleteSetting = async (id) => {
        if (!confirm('この設定を削除しますか？')) {
            return;
        }
        try {
            await deleteAiSetting(id);
            dispatch(removeAiSetting(id));
        }
        catch (error) {
            dispatch(setAiSettingError('設定の削除に失敗しました'));
        }
    };
    return (React.createElement("div", { className: "ai-setting-list-container" },
        React.createElement("div", { className: "ai-setting-list-header" },
            React.createElement("h3", null, "\uD83E\uDD16 AI\u8A2D\u5B9A\u7BA1\u7406"),
            React.createElement("button", { onClick: handleNewSetting, className: "ai-setting-list-button ai-setting-list-button--primary", disabled: _loading }, "\u65B0\u898F\u4F5C\u6210")),
        React.createElement("div", { className: "ai-setting-list-content-wrapper" },
            _error && (React.createElement("div", { className: "ai-setting-list-error" },
                "\u274C ",
                _error,
                React.createElement("button", { onClick: loadSettings, className: "ai-setting-list-retry" }, "\u518D\u8A66\u884C"))),
            _loading && (React.createElement("div", { className: "ai-setting-list-loading" },
                React.createElement("div", { className: "ai-setting-list-spinner" }),
                React.createElement("p", null, "\u8A2D\u5B9A\u3092\u8AAD\u307F\u8FBC\u307F\u4E2D..."))),
            !_loading && _settings.length === 0 && !_error && (React.createElement("div", { className: "ai-setting-list-empty" },
                React.createElement("div", { className: "ai-setting-list-empty-icon" }, "\u2699\uFE0F"),
                React.createElement("h4", null, "AI\u8A2D\u5B9A\u304C\u3042\u308A\u307E\u305B\u3093"),
                React.createElement("p", null, "\u65B0\u3057\u3044AI\u8A2D\u5B9A\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044"))),
            !_loading && _settings.length > 0 && (React.createElement("div", { className: "ai-setting-list-grid" }, _settings.map(setting => (React.createElement("div", { key: setting.id, className: "ai-setting-list-card" },
                React.createElement("div", { className: "ai-setting-list-card-header" },
                    React.createElement("h4", null, setting.ai_name)),
                React.createElement("div", { className: "ai-setting-list-card-content" },
                    React.createElement("div", { className: "ai-setting-list-info" },
                        React.createElement("span", { className: "ai-setting-list-label" }, "\u30C9\u30E1\u30A4\u30F3:"),
                        React.createElement("span", null, setting.jitsi_config?.domain || 'N/A')),
                    React.createElement("div", { className: "ai-setting-list-info" },
                        React.createElement("span", { className: "ai-setting-list-label" }, "ChatGPT\u30E2\u30C7\u30EB:"),
                        React.createElement("span", null, setting.chat_config?.response?.chatgpt_model_name || 'N/A')),
                    React.createElement("div", { className: "ai-setting-list-info" },
                        React.createElement("span", { className: "ai-setting-list-label" }, "\u30D3\u30C7\u30AA\u30DC\u30C3\u30C8:"),
                        React.createElement("span", { className: `ai-setting-list-status ${setting.jitsi_config?.videobot?.activate ? 'active' : 'inactive'}` }, setting.jitsi_config?.videobot?.activate ? '有効' : '無効')),
                    setting.updated_at && (React.createElement("div", { className: "ai-setting-list-timestamp" },
                        "\u6700\u7D42\u66F4\u65B0: ",
                        new Date(setting.updated_at).toLocaleDateString('ja-JP')))),
                React.createElement("div", { className: "ai-setting-list-card-actions" },
                    React.createElement("button", { onClick: () => handleViewSetting(setting), className: "ai-setting-list-button ai-setting-list-button--view" }, "\u8A73\u7D30"),
                    React.createElement("button", { onClick: () => handleEditSetting(setting), className: "ai-setting-list-button ai-setting-list-button--edit" }, "\u7DE8\u96C6"),
                    React.createElement("button", { onClick: () => handleDeleteSetting(setting.id), className: "ai-setting-list-button ai-setting-list-button--delete" }, "\u524A\u9664")))))))),
        React.createElement(AiSettingModal, { isOpen: modalConfig.isOpen, mode: modalConfig.mode, settingId: modalConfig.settingId, settingData: modalConfig.settingData, onClose: handleCloseModal, onSaveSuccess: handleSaveSuccess })));
};
/**
 * Redux stateをpropsにマッピング
 */
function mapStateToProps(state) {
    const aiSettingState = state['features/ai_setting'];
    return {
        _settings: aiSettingState.settings,
        _loading: aiSettingState.loading,
        _error: aiSettingState.error
    };
}
export default translate(connect(mapStateToProps)(AiSettingList));
